import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ClientReferralMatchOption } from 'app/core/models/client-referral-match-option.model';
import { ClientReferralVerification } from 'app/core/models/client-referral-verification.model';
import { NgClass, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { JoinListPipe } from '../../pipes/join-list.pipe';
import { BlankValueDashPipe } from '../../pipes/blank-value-dash.pipe';
import { ReferralVerificationReasonShortNamesPipe } from '../../pipes/referral-verification-reason-short-names.pipe';
import { SpecialtyBadgesComponent } from '../specialty-badges/specialty-badges.component';

type ListingIterable = ClientReferralMatchOption | ClientReferralVerification;

@Component({
    selector: 'app-referrals-client-listing',
    templateUrl: './referrals-client-listing.component.html',
    styleUrls: ['./referrals-client-listing.component.scss'],
    imports: [NgClass,
              FormsModule,
              MatProgressSpinner,
              DatePipe,
              JoinListPipe,
              BlankValueDashPipe,
              ReferralVerificationReasonShortNamesPipe,
              SpecialtyBadgesComponent]
})
export class ReferralsClientListingComponent {
  @Input() loading = false;
  @Input() compactClientView = false;
  @Input() dark = false;

  @Input() referralMatchOptions: ClientReferralMatchOption[];
  @Input() clientReferralVerifications: ClientReferralVerification[];

  @Output() referralVerificationChange = new EventEmitter<ClientReferralMatchOption>();

  onReferralVerificationChange(referralMatchOption: ClientReferralMatchOption) {
    this.referralVerificationChange.emit(referralMatchOption);
  }

  get verificationsOrOptions(): ListingIterable[] {
    return this.referralMatchOptions || this.clientReferralVerifications;
  }

  verification(item: ListingIterable): ClientReferralVerification {
    if (item instanceof ClientReferralMatchOption) {
      return item.clientReferralVerification;
    } else {
      return item as ClientReferralVerification;
    }
  }

  option(item: ListingIterable): ClientReferralMatchOption {
    if (item instanceof ClientReferralMatchOption) {
      return item;
    }
  }
}
